import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import { useEffect, useRef } from '@wordpress/element';

import metadata from './block.json';
import Style from './Style';

export default function Edit( props ) {
	const { attributes, setAttributes, clientId } = props;
	const { blockID, content, level, typography, backgroundColor } = attributes;
	const { fontFamily } = typography || {};

	const contentRef = useRef( null );

	useEffect( () => {
		if ( ! attributes.blockID || blockID !== blockID ) {
			setAttributes( { blockID: clientId } );
		}
	}, [ clientId ] );

	useEffect( () => {
		if ( contentRef.current && Alpine ) {
			if (
				typeof Alpine?.$data( contentRef.current )?.loadGoogleFonts ===
				'function'
			) {
				Alpine?.$data( contentRef.current )?.loadGoogleFonts(
					[ fontFamily ].filter( ( f ) => f && f !== 'default' )
				);
			}
		}
	}, [ typography ] );

	const blockProps = useBlockProps( {
		className: `block-${ blockID }`,
		'x-data': 'heading',
		'data-font-families': [ fontFamily ],
		ref: contentRef,
	} );

	const tagName = level || 'p';

	return (
		<>
			<window.InspectorGenerator props={ props } blockJson={ metadata } />
			<Style
				attributes={ attributes }
				blockID={ blockID }
				setAttributes={ setAttributes }
			/>
			<RichText
				{ ...blockProps }
				tagName={ tagName }
				value={ content }
				allowedFormats={ [ 'core/bold', 'core/italic' ] }
				onChange={ ( val ) => setAttributes( { content: val } ) }
				placeholder={ __( 'Add text…', 'alpha-blocks' ) }
			/>
		</>
	);
}
